import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "BaseTemplateDigitalMenuLayers" }
const _hoisted_2 = { class: "flex justify-center q-mb-20" }
const _hoisted_3 = {
  key: 0,
  class: "column gap-sm"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "q-mb-20 fs-15px fw-500 text-cool-gray-100" }

import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'
import BaseTemplateLayerItem from './BaseTemplateLayerItem.vue'
import useDrag from 'src/hook/useDrag.js'
import { useTemplateStore } from 'src/stores'
import type { ITemplateDeleteItemParam } from 'src/common/interfaces'
import { computed, reactive, ref, watch } from 'vue'
import { TemplateBackgroundTypeEnum } from 'src/common/enums'
import placeholderImage from 'src/assets/default-image.svg'

interface IEmits {
  (event: 'delete', data: ITemplateDeleteItemParam): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseTemplateDigitalMenuLayers' },
  __name: 'BaseTemplateDigitalMenuLayers',
  emits: ["delete"],
  setup(__props) {




const dragHook = useDrag()
const { t } = translate(translationObject)
const templateStore = useTemplateStore()

const state = reactive({
  activeTab: 'layers',
  tabs: [
    {
      label: t('digital_menu.layers'),
      icon: 'hamburger-menu',
      name: 'layers',
      attrs: { style: 'padding: 0' },
    },
    {
      label: t('digital_menu.screen_settings'),
      icon: 'system-setting',
      name: 'settings',
      attrs: { style: 'padding: 0' },
    },
  ],
})

const images = ref(
  templateStore.background
    ? [
        typeof templateStore.background === 'string'
          ? `${templateStore.background}?t=${Date.now()}`
          : templateStore.background,
      ]
    : [],
)

const templateItems = computed(() => templateStore.layers[0].items)

async function handleTemplateImage($event: File) {
  if (Array.isArray($event) && $event.length) {
    templateStore.backgroundType = TemplateBackgroundTypeEnum.IMAGE
    templateStore.handleSetBackground({ blob: URL.createObjectURL($event[0]), file: $event[0] })
  }
}
function handleBackgroundColor($event: string | null) {
  if ($event === null) return
  templateStore.backgroundType = TemplateBackgroundTypeEnum.COLOR
  templateStore.handleSetBackground($event)
  images.value = []
}

watch(
  () => templateStore.backgroundType,
  (newBgType) => {
    const isColor = newBgType === TemplateBackgroundTypeEnum.COLOR
    const isImage = newBgType === TemplateBackgroundTypeEnum.IMAGE

    if (
      (isColor && typeof templateStore.background !== 'string') ||
      (isImage && typeof templateStore.background === 'string')
    )
      templateStore.handleSetBackground('')
  },
)

return (_ctx: any,_cache: any) => {
  const _component_k_tab = _resolveComponent("k-tab")!
  const _component_EmptyListAlert = _resolveComponent("EmptyListAlert")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_radio = _resolveComponent("k-radio")!
  const _component_k_colour_code = _resolveComponent("k-colour-code")!
  const _component_BaseUploader = _resolveComponent("BaseUploader")!
  const _component_k_tab_panel = _resolveComponent("k-tab-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_k_tab, {
        modelValue: state.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.activeTab) = $event)),
        tabs: state.tabs,
        "tab-box-style": "flex: 1"
      }, null, 8, ["modelValue", "tabs"])
    ]),
    _createVNode(_component_k_tab_panel, {
      modelValue: state.activeTab,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.activeTab) = $event)),
      "tab-panel-class": "q-pa-none overflow-auto hide-scrollbar"
    }, {
      layers: _withCtx(() => [
        (templateItems.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateItems.value, (item, itemIndex) => {
                return (_openBlock(), _createBlock(BaseTemplateLayerItem, {
                  key: item.id,
                  item: item,
                  "layer-index": 0,
                  "is-active": _unref(templateStore)?.activeItem?.id === item.id,
                  onClick: ($event: any) => (_unref(templateStore).handleActiveItem(item)),
                  onToggleShow: ($event: any) => (_unref(templateStore).handleToggleShow(0, itemIndex)),
                  onItemDragstart: _unref(dragHook).handleDragStart,
                  onItemDragend: _cache[1] || (_cache[1] = ($event: any) => (
              _unref(dragHook).handleDragEnd({
                items: templateItems.value,
                callback: _unref(templateStore).handleRowDragged,
                layerIndex: 0,
              })
            )),
                  onItemDragover: _unref(dragHook).handleDragOver,
                  onDelete: ($event: any) => (_ctx.$emit('delete', { layerIndex: 0, itemIndex }))
                }, null, 8, ["item", "is-active", "onClick", "onToggleShow", "onItemDragstart", "onItemDragover", "onDelete"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_EmptyListAlert, {
                "root-class": "q-pt-md q-pb-xl q-px-xs",
                title: _unref(t)('digital_menu.empty_layer.title'),
                description: _unref(t)('digital_menu.empty_layer.description'),
                icon: "no-layer"
              }, null, 8, ["title", "description"])
            ]))
      ]),
      settings: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_k_input, {
            modelValue: _unref(templateStore).templateName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(templateStore).templateName) = $event)),
            "external-label": _unref(t)('template_name')
          }, null, 8, ["modelValue", "external-label"]),
          _createVNode(_component_k_divider, {
            size: "md",
            class: "q-my-20"
          }),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('digital_menu.set_screen_background')), 1),
          _createVNode(_component_k_radio, {
            modelValue: _unref(templateStore).backgroundType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(templateStore).backgroundType) = $event)),
            class: "q-mb-md",
            label: _unref(t)('digital_menu.select_background_colour'),
            val: _unref(TemplateBackgroundTypeEnum).COLOR
          }, null, 8, ["modelValue", "label", "val"]),
          _createVNode(_component_k_colour_code, {
            colors: _unref(templateStore).colours,
            "onUpdate:colors": _cache[4] || (_cache[4] = ($event: any) => ((_unref(templateStore).colours) = $event)),
            "has-transparency": false,
            "model-value": 
              _unref(templateStore).backgroundType === _unref(TemplateBackgroundTypeEnum).COLOR ? _unref(templateStore).background : null
            ,
            "onUpdate:modelValue": handleBackgroundColor
          }, null, 8, ["colors", "model-value"]),
          _createVNode(_component_k_divider, {
            class: "q-my-20",
            dotted: ""
          }),
          _createVNode(_component_k_radio, {
            modelValue: _unref(templateStore).backgroundType,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(templateStore).backgroundType) = $event)),
            class: "q-mb-md",
            label: _unref(t)('digital_menu.upload_background_image'),
            val: _unref(TemplateBackgroundTypeEnum).IMAGE
          }, null, 8, ["modelValue", "label", "val"]),
          _createVNode(_component_BaseUploader, {
            id: "digital_menu_background",
            modelValue: images.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((images).value = $event)),
            "max-item": 1,
            "placeholder-type": "bill",
            "placeholder-src": _unref(placeholderImage),
            accept: "image/jpeg",
            "onUpdate:newImage": handleTemplateImage,
            onOnDelete: _cache[7] || (_cache[7] = ($event: any) => (_unref(templateStore).handleSetBackground('')))
          }, null, 8, ["modelValue", "placeholder-src"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})